export default __webpack_public_path__ + "static/media/MedicineDelivery.5f01b9f0.svg";